module.exports = __webpack_public_path__ + "img/logo.f9005a0c.png";